module.exports = __webpack_public_path__ + "img/p6.e06a8508.png";